import React from "react"
import {Row, Col} from 'antd/lib/index'

import './FooterLayout.less'

function FooterLayout() {
    return (
        <div className="footer_layout">
            <Row>
                <Col sm={0} md={4}></Col>
                <Col sm={24} md={16}>
                    <div className="footer_wrapper">
                        <div className="footer_website">
                            <ul>
                                {listItems}
                            </ul>
                        </div>
                        <div className="footer_contact_us">
                            联系我们：<a href="mailto:e-book@amegroups.com">e-book@amegroups.com</a>
                        </div>
                        <div className="footer_copyright">
                            <span>Copyright © 2009-{(new Date()).getFullYear()} AME Publishing Company. All rights reserved.</span>
                        </div>
                    </div>
                </Col>
                <Col sm={0} md={4}></Col>
            </Row>
        </div>
    )
}

const webSites = [{
    id: 1,
    siteName: 'AME官网',
    link: 'http://www.amegroups.com/'
}, {
    id: 2,
    siteName: 'AME图书',
    link: 'http://ebook.amegroups.cn'
}, {
    id: 3,
    siteName: '认领系统',
    link: 'http://rlxt.amegroups.cn'
}, {
    id: 4,
    siteName: 'ABER',
    link: 'http://www.theaber.com'
}, {
    id: 5,
    siteName: 'AME图书APP',
    link: 'http://ebook.amegroups.cn/introductory-page'
}, {
    id: 6,
    siteName: '积分商城',
    link: 'http://webstore.amegroups.cn'
}, {
    id: 7,
    siteName: 'AME Editing Service',
    link: 'http://editing.amegroups.com'
}, {
    id: 8,
    siteName: '关于AME',
    link: 'http://www.amegroups.com/who-we-are'
}
]
const listItems = webSites.map((item) =>
    <li key={item.id}>
        <a href={item.link} target="_blank">{item.siteName}</a>
    </li>
)

export default FooterLayout
